import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { t } from "i18next";
import { toast } from "sonner";
import { createFeedbackApi, deleteFeedbackById, getProfileFeedbacksByUserId, updateFeedbackApi } from "../api/feedbacks/feedbacksApi";
import { queryClient } from "../main";


export const useCreateFeedback = () => {
    return useMutation({
        mutationFn: createFeedbackApi,
    });
};

export const useGetProfileFeedbacks = (userId: number) => {
    return useQuery({
        // userId must be part of the key so different profiles don't share
        // (and stomp on) one cached list of reviews.
        queryKey: ["profileFeedbacks", userId],
        queryFn: () => getProfileFeedbacksByUserId(userId),
        enabled: !!userId,
    });
};

export const useDeleteFeedback = (setDeleteOpen: () => void) => {
    return useMutation({
        mutationFn: (id: number) => deleteFeedbackById(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["profileFeedbacks"] });
            setDeleteOpen();
            toast.success(t("feedback.deleteSuccess"));
        },
        onError: () => {
            setDeleteOpen();
            toast.error(t("feedback.deleteError"));
        },
    });
};

export function useUpdateFeedback(onSuccess?: () => void) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateFeedbackApi,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["profileFeedbacks"] });
            toast.success("Отзыв обновлён");
            onSuccess?.();
        },
        onError: (err: any) => {
            toast.error(err?.message ?? "Не удалось обновить отзыв");
        },
    });
}